<template>
  <v-row class="">
    <div class="flow-line">
      <div class="pt-8 flow-line-inside">&nbsp;</div>
    </div>
    <v-card outlined class="mx-auto py-1 px-8" width="95%" elevation="1">
      <v-row class="">
        <v-col cols="11" class="pt-0 px-0 mx-0"
          ><v-card-title>{{
            ForwardMulti ? "Multi-Ring" : "Forward"
          }}</v-card-title></v-col
        >
        <v-col cols="1" class="px-0">
          <v-menu open-on-click left offset-y class="setup-settings-menu">
            <template
              v-slot:activator="{ on, attrs }"
              class="setup-settings-menu2"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn icon v-bind="attrs" v-on="{ ...on, ...tooltip }">
                    <v-icon>mdi-cog</v-icon>
                  </v-btn>
                </template>
                <span>Options</span>
              </v-tooltip>
            </template>
            <div class="ma-6">
              <v-switch
                :disabled="PreviewMode"
                :label="
                  enableCallRecording
                    ? 'Use Call Recording'
                    : 'No Call Recording'
                "
                v-model="enableCallRecording"
                @change="onUpdateAnything"
                class="pt-3"
                dense
              ></v-switch>
            </div>
            <div class="ma-6">
              <v-switch
                :disabled="PreviewMode"
                :label="hasCallWhisper ? 'Use Call Whisper' : 'No Call Whisper'"
                v-model="hasCallWhisper"
                @change="onUpdateAnything"
                class="pt-3"
                dense
              ></v-switch>
            </div>
          </v-menu>
        </v-col>
      </v-row>

      <v-row class="pa-3">
        <v-col>
          <v-autocomplete
            :disabled="PreviewMode"
            required
            :rules="[rules.required]"
            v-model="forwardNumbersSelected"
            @change="onUpdateAnything"
            :items="forwardingPhones.items"
            item-text="name"
            item-value="id"
            :filter="forwardingPhoneCustomFilter"
            :label="
              ForwardMulti
                ? 'Select Desination Phone Numbers'
                : 'Select a Desination Phone Number'
            "
            dense
            chips
            :multiple="ForwardMulti"
            autocomplete="off"
            outlined
          >
            <template v-slot:selection="data">
              <v-chip
                :disabled="PreviewMode"
                small
                v-bind="data.attrs"
                :input-value="data.selected"
                :close="ForwardMulti"
                @click="data.select"
                @click:close="removePhoneItem(data.item)"
                class="double-chip"
              >
                <span class="top-chip-name">{{ data.item.name }}</span
                ><br /><span class="selected-phone">{{
                  data.item.meta.display
                }}</span>
              </v-chip>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
                <v-list-item-subtitle
                  v-text="item.meta.display"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12">
          <v-text-field
            :disabled="PreviewMode"
            label="Dial Timeout (in seconds)"
            hint="If this timeout passes we'll continue to the next step in the call flow."
            persistent-hint
            required
            :rules="[rules.required, rules.number]"
            v-model="dialTimeoutSeconds"
            v-mask="masks.number"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row class="pa-3" v-if="enableCallRecording">
        <v-col>
          <v-list-item-title>Call Recording Message</v-list-item-title>
        </v-col>
        <v-col cols="12">
          <v-radio-group
            :disabled="PreviewMode"
            v-model="callRecordingIsTTS"
            row
            dense
            @change="updateCallRecordingRecordedMessageType"
          >
            <v-radio label="Text to Speech" :value="true"></v-radio>
            <v-radio label="Upload Audio File" :value="false"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col
          cols="12"
          class="my-0 py-0"
          v-if="recordingRecordedMessageType == 'audiofile'"
        >
          <v-sheet>
            <v-file-input
              :disabled="PreviewMode"
              :accept="acceptAudioFormats"
              label="Audio File for Call Recording Message"
              hint="Upload a MP3 or WAV file"
              persistent-hint
              dense
              aria-required="Call recording message text is required"
              required
              :rules="[rules.required]"
              @change="onCallRecordingAudioUrlChanged"
              @click:clear="recordingAudioUrl = ''"
              outlined
            ></v-file-input>
            <v-lazy>
              <audio
                v-if="recordingAudioUrl"
                controls
                :src="`${recordingUrl}`"
                @play="setPlayerStatus('play')"
                @pause="setPlayerStatus('pause')"
                @ended="setPlayerStatus('ended')"
                class="recording-controls"
              ></audio>
            </v-lazy>
          </v-sheet>
        </v-col>
        <v-col
          cols="12"
          class="my-0 py-0"
          v-if="recordingRecordedMessageType == 'tts'"
        >
          <v-textarea
            :disabled="PreviewMode"
            label="Text to Speech Call Recording Message"
            v-model="recordingTtsText"
            @input="onUpdateAnything"
            class="py-1"
            dense
            auto-grow
            rows="2"
            aria-required="Call recording message text is required"
            required
            :rules="[rules.required]"
            outlined
          ></v-textarea>
          <v-lazy>
            <audio
              v-if="callRecordingTtsAudioUrl"
              controls
              :src="`${recordingUrl}`"
              @play="setPlayerStatus('play')"
              @pause="setPlayerStatus('pause')"
              @ended="setPlayerStatus('ended')"
              class="recording-controls"
            ></audio>
          </v-lazy>
        </v-col>
        <v-col cols="12">
          <v-checkbox
            v-model="transcribeRecording"
            @change="onUpdateAnything"
            :label="
              transcribeRecording
                ? 'Transcribe Recordings'
                : 'Don\'t Transcribe Recordings'
            "
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row class="pa-3" v-if="hasCallWhisper">
        <v-col>
          <v-list-item-title>Call Whisper Message</v-list-item-title>
        </v-col>
        <v-col cols="12" class="pb-0" dense>
          <v-switch
            :disabled="PreviewMode"
            v-model="callWhisperPressAnyKeyAccept"
            dense
            @change="onUpdateAnything"
            :label="
              callWhisperPressAnyKeyAccept
                ? 'Press any key to accept call (hang up to decline)'
                : 'Auto-accept after message (hang up to decline)'
            "
          ></v-switch>
        </v-col>
        <v-col cols="12" class="pt-0 mt-0" dense>
          <v-radio-group
            :disabled="PreviewMode"
            v-model="callWhisperIsTTS"
            row
            dense
            @change="updateCallWhisperRecordedMessageType"
          >
            <v-radio label="Text to Speech" :value="true"></v-radio>
            <v-radio label="Upload Audio File" :value="false"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col
          cols="12"
          class="my-0 py-0"
          v-if="whisperRecordedMessageType == 'audiofile'"
        >
          <v-sheet>
            <v-file-input
              :disabled="PreviewMode"
              :accept="acceptAudioFormats"
              label="Audio File for Call Whisper Message"
              hint="Upload a MP3 or WAV file"
              persistent-hint
              dense
              aria-required="Call whisper message text is required"
              required
              :rules="[rules.required]"
              @change="onCallWhisperAudioUrlChanged"
              @click:clear="whisperAudioUrl = ''"
              outlined
            ></v-file-input>
            <v-lazy>
              <audio
                v-if="whisperAudioUrl"
                controls
                :src="`${recordingWhisperUrl}`"
                @play="setPlayerStatus('play')"
                @pause="setPlayerStatus('pause')"
                @ended="setPlayerStatus('ended')"
                class="recording-controls"
              ></audio>
            </v-lazy>
          </v-sheet>
        </v-col>
        <v-col
          cols="12"
          class="my-0 py-0"
          v-if="whisperRecordedMessageType == 'tts'"
        >
          <v-textarea
            :disabled="PreviewMode"
            label="Text to Speech Call Whisper Message"
            v-model="whisperTtsText"
            @input="onUpdateAnything"
            class="py-1"
            dense
            auto-grow
            rows="2"
            aria-required="Call whisper message text is required"
            required
            :rules="[rules.required]"
            outlined
          ></v-textarea>
          <v-lazy>
            <audio
              v-if="whisperTtsAudioUrl"
              controls
              :src="`${recordingWhisperUrl}`"
              @play="setPlayerStatus('play')"
              @pause="setPlayerStatus('pause')"
              @ended="setPlayerStatus('ended')"
              class="recording-controls"
            ></audio>
          </v-lazy>
        </v-col>
      </v-row>

      <v-btn
        :disabled="PreviewMode"
        text
        icon
        color="error"
        @click="onRemoveMe"
        class="float-right"
      >
        Remove
      </v-btn>
    </v-card>
  </v-row>
</template>

<script>
import { VALIDATION_RULES } from "../../../helpers/ValidationRules";
import hashCode from "../../../helpers/hashCode";
import { API_BASE_URL } from "../../../globalVars";
import axios from "axios";
import { MASKS } from "../../../helpers/Masks";
import { mask } from "vue-the-mask";

export default {
  name: "CallFlowForward",
  components: {},
  directives: {
    mask
  },
  props: {
    order: {
      type: Number,
      required: true
    },
    ForwardMulti: {
      type: Boolean,
      required: true
    },
    updateCallback: {
      type: Function,
      required: false
    },
    onRemove: {
      type: Function,
      required: true
    },
    flowList: {
      type: Array,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    PreviewMode: {
      type: Boolean,
      required: true
    }
  },
  data: function() {
    return {
      rules: VALIDATION_RULES,
      masks: MASKS,

      acceptAudioFormats: "audio/mp3,audio/mpeg,audio/x-wav",
      playerStatus: "new",

      enableCallRecording: false,
      callRecordingIsTTS: true,
      recordingRecordedMessageType: "tts",
      recordingTtsText: "",
      recordingAudioUrl: "",
      callRecordingTtsAudioUrl: null,
      transcribeRecording: true,
      recordingUrl: null,

      forwardNumbersSelected: [],
      forwardNumbers: [],
      dialTimeoutSeconds: 15,

      hasCallWhisper: false,
      callWhisperIsTTS: true,
      whisperRecordedMessageType: "tts",
      whisperTtsText: "",
      whisperAudioUrl: "",
      whisperTtsAudioUrl: null,
      callWhisperPressAnyKeyAccept: false,
      whisperAcceptOnKeypress: false,
      recordingWhisperUrl: null
    };
  },
  created() {
    const vueThis = this;
    if (
      this.order != null &&
      this.flowList.length > 0 &&
      this.flowList[this.order] &&
      this.flowList[this.order].recordingRecordedMessageType
    ) {
      const tempData = Object.assign({}, this.flowList[this.order]);
      this.enableCallRecording = tempData.enableCallRecording;
      this.transcribeRecording = tempData.transcribeRecording;
      this.callRecordingIsTTS = this.recordingRecordedMessageType == "tts";
      this.recordingRecordedMessageType = tempData.recordingRecordedMessageType;
      this.recordingTtsText = tempData.recordingTtsText;
      this.recordingAudioUrl = tempData.recordingAudioUrl;
      this.updateRecordingUrl(tempData.recordingAudioUrl);
      if (this.recordingRecordedMessageType == "tts") {
        const hashCodeFromText = hashCode(this.recordingTtsText);
        this.callRecordingTtsAudioUrl = `telephony/call-flow/${tempData.uid}/${hashCodeFromText}.mp3`;
        this.updateRecordingUrl(
          `telephony/call-flow/${tempData.uid}/${hashCodeFromText}.mp3`
        );
      }
      this.forwardNumbers = tempData.forwardNumbers;
      if (tempData.forwardNumbers) {
        this.forwardNumbersSelected = tempData.forwardNumbers.map(value =>
          vueThis.forwardingPhones.items.filter(
            num => num.meta.value == value
          )[0]
            ? vueThis.forwardingPhones.items.filter(
                num => num.meta.value == value
              )[0].id
            : null
        );
      }
      if (
        !this.ForwardMulti &&
        this.forwardNumbersSelected &&
        this.forwardNumbersSelected.length > 0
      ) {
        this.forwardNumbersSelected = this.forwardNumbersSelected[0];
      }

      this.dialTimeoutSeconds = tempData.dialTimeoutSeconds;

      this.hasCallWhisper = tempData.hasCallWhisper;
      this.callWhisperIsTTS = this.whisperRecordedMessageType == "tts";
      this.whisperRecordedMessageType = tempData.whisperRecordedMessageType;
      this.whisperTtsText = tempData.whisperTtsText;
      this.whisperAudioUrl = tempData.whisperAudioUrl;
      this.updateWhisperRecordingUrl(this.whisperAudioUrl);
      if (this.whisperRecordedMessageType == "tts") {
        const hashCodeFromText = hashCode(this.whisperTtsText);
        this.whisperTtsAudioUrl = `telephony/call-flow/${tempData.uid}/${hashCodeFromText}.mp3`;
        this.updateWhisperRecordingUrl(this.whisperTtsAudioUrl);
      }
      this.callWhisperPressAnyKeyAccept = tempData.whisperAcceptOnKeypress;
      this.whisperAcceptOnKeypress = tempData.whisperAcceptOnKeypress;
    }
  },
  computed: {
    account() {
      return this.$store.getters["entities/accounts/query"]()
        .withAllRecursive(1)
        .first();
    },
    forwardingPhoneTypeId() {
      let listType = this.$store.getters["entities/listTypes/query"]()
        .where("code", value => ["forwarding_number"].includes(value))
        .first();
      if (listType && listType.id) {
        return listType.id;
      }
      return null;
    },
    forwardingPhones() {
      const listType = this.$store.getters["entities/listTypes/query"]()
        .withAllRecursive(1)
        .where("code", value => ["forwarding_number"].includes(value))
        .first();
      return listType;
    }
  },
  methods: {
    updateCallRecordingRecordedMessageType() {
      if (this.callRecordingIsTTS) {
        this.recordingRecordedMessageType = "tts";
      } else {
        this.recordingRecordedMessageType = "audiofile";
      }
      this.recordingUrl = null;
      this.onUpdateAnything();
    },
    onCallRecordingAudioUrlChanged(args) {
      let recordingFile = args;
      this.uploadRecordingFile({
        type: "call-flow",
        recordingFile,
        recordingType: "call-recording"
      });
    },
    updateCallWhisperRecordedMessageType() {
      if (this.callWhisperIsTTS) {
        this.whisperRecordedMessageType = "tts";
      } else {
        this.whisperRecordedMessageType = "audiofile";
      }
      this.onUpdateAnything();
    },
    onCallWhisperAudioUrlChanged(args) {
      let recordingFile = args;
      this.uploadRecordingFile({
        type: "call-flow",
        recordingFile,
        recordingType: "call-whisper"
      });
    },
    uploadRecordingFile({ type, recordingFile, recordingType }) {
      if (!recordingFile) {
        return;
      }
      // do the upload
      let vueThis = this;
      let formData = new FormData();
      formData.append("file", recordingFile);
      axios({
        method: "get",
        url:
          API_BASE_URL +
          `/file-upload/telecom-recording?type=${type}&contenttype=${
            recordingFile.type
          }&name=${encodeURIComponent(recordingFile.name)}&uid=${
            vueThis.config.uid
          }`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      })
        .then(response => {
          axios
            .put(response.data.url, recordingFile, {
              headers: {
                "Content-Type": recordingFile.type
              }
            })
            .then(function(putResponse) {
              const url = putResponse.config.url.split("?")[0].split("/");
              const newValue = [url[6], url[7], url[8], url[9]].join("/");
              if (recordingType == "call-recording") {
                vueThis.recordingAudioUrl = newValue;
                vueThis.updateRecordingUrl(newValue);
              } else if (recordingType == "call-whisper") {
                vueThis.whisperAudioUrl = newValue;
                vueThis.updateWhisperRecordingUrl(newValue);
              } else {
                console.error("oops no recordingType");
              }
              vueThis.onUpdateAnything();
            })
            .catch(function(error) {
              console.error("Unable to upload file ", error);
            });
        })
        .catch(error => {
          console.error("Unable to get an signed upload URL", error);
        });
    },
    updateRecordingUrl(path) {
      if (!path) return;
      const vueThis = this;
      const externalId = this.account.externalId;
      axios({
        method: "get",
        url:
          API_BASE_URL +
          `/account?do=file-url&externalId=${externalId}&path=account/${externalId}/${path}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      }).then(response => {
        vueThis.recordingUrl =
          response && response.data ? response.data.url : null;
      });
    },
    updateWhisperRecordingUrl(path) {
      if (!path) return;
      const vueThis = this;
      const externalId = this.account.externalId;
      axios({
        method: "get",
        url:
          API_BASE_URL +
          `/account?do=file-url&externalId=${externalId}&path=account/${externalId}/${path}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      }).then(response => {
        vueThis.recordingWhisperUrl =
          response && response.data ? response.data.url : null;
      });
    },
    setPlayerStatus(status) {
      this.playerStatus = status;
    },
    onRemoveMe() {
      this.onRemove(this.config.uid);
    },
    onUpdateAnything() {
      const vueThis = this;
      const newConfig = Object.assign({}, this.config);
      newConfig.order = this.order;
      newConfig.enableCallRecording = this.enableCallRecording;
      newConfig.transcribeRecording = this.transcribeRecording;
      newConfig.recordingRecordedMessageType = this.recordingRecordedMessageType;
      newConfig.recordingTtsText = this.recordingTtsText;
      newConfig.recordingAudioUrl = this.recordingAudioUrl;
      // vueThis.updateRecordingUrl(this.recordingAudioUrl);

      if (this.forwardNumbers) {
        newConfig.forwardNumbers = (typeof vueThis.forwardNumbersSelected ==
        "object"
          ? vueThis.forwardNumbersSelected
          : [vueThis.forwardNumbersSelected]
        ).map(
          value =>
            vueThis.forwardingPhones.items.filter(num => num.id == value)[0]
              .meta.value
        );
        this.forwardNumbers = newConfig.forwardNumbers;
      }
      newConfig.dialTimeoutSeconds = this.dialTimeoutSeconds;

      newConfig.hasCallWhisper = this.hasCallWhisper;
      newConfig.whisperRecordedMessageType = this.whisperRecordedMessageType;
      newConfig.whisperTtsText = this.whisperTtsText;
      newConfig.whisperAudioUrl = this.whisperAudioUrl;
      // vueThis.updateWhisperRecordingUrl(this.whisperAudioUrl);
      newConfig.whisperAcceptOnKeypress = this.callWhisperPressAnyKeyAccept;

      this.updateCallback(this.order, newConfig);
    },
    forwardingPhoneCustomFilter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const textTwo = item.meta.display.toLowerCase();
      const searchText = queryText.toLowerCase();
      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      );
    },
    removePhoneItem(item) {
      const index = this.forwardNumbers.indexOf(item.id);
      if (index >= 0) {
        this.forwardNumbers.splice(index, 1);
      }
    }
  },
  watch: {
    recordingTtsText(newVal, oldVal) {
      if (oldVal != "" && oldVal != newVal) {
        this.callRecordingTtsAudioUrl = null;
      }
    },
    whisperTtsText(newVal, oldVal) {
      if (oldVal != "" && oldVal != newVal) {
        this.whisperTtsAudioUrl = null;
      }
    }
  }
};
</script>

<style scoped lang="stylus">
.call-flow-icon {
  color: #1976d2 !important;
  caret-color: #1976d2 !important;
  font-weight: 400;
}
.flow-line {
  height: 3rem;
  width: 100%;
}
.flow-line-inside {
  height: 3rem;
  width: 50%;
  border-right: 1px solid #cccccc;
}
.selected-phone {
  padding-left: .5rem;
}
span.double-chip  span.v-chip__content{
  display: flex;
}
div.menu__content.theme--light {
  background-color: white;
}
</style>
